import React from "react";
import { useTranslation } from 'react-i18next';

export default function OtherServiece(props) {
  const { isMobile } = props;
  const { t } = useTranslation();
  return (
    <div className="py-5 p-xl-5 bg-light">
      <div className="text-center mb-4">
        <h2 className="font-weight-900 mt-3 mt-xl-0 mb-3 lineUp">
          {t('otherService.title')}
        </h2>
        <h3 className="font-weight-600">
          <p className="px-2 px-xl-0">
            {t('otherService.description')}
          </p>
        </h3>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-center">
        <div
          className="d-flex flex-column justify-content-between p-4 shadow rounded-lg bg-white mb-3 mx-3 mx-xl-0 mb-xl-0"
          style={{ maxWidth: isMobile ? "unset" : 320 }}
        >
          {isMobile && (
            <h4 className="font-weight-900 text-freiscop text-center mb-2 mb-md-0">
              <p>
                {t('otherService.chatGpt.title')}
                <br />
                {t('otherService.chatGpt.subtitle')}
              </p>
            </h4>
          )}
          <div className="d-flex flex-row flex-md-column align-items-center justify-content-between">
            <div className="d-flex flex-column align-items-center">
              {!isMobile && (
                <h4 className="font-weight-900 text-freiscop text-center">
                  <p>
                    {t('otherService.chatGpt.title')}
                    <br />
                    {t('otherService.chatGpt.subtitle')}
                  </p>
                </h4>
              )}
              <div className="mr-3 mr-md-0 my-md-4">
                <img
                  width={isMobile ? "60px" : "unset"}
                  src="/img/info/chat_gpt.png"
                  alt="chat_gpt"
                />
              </div>
            </div>
            <p className="h6 m-0 text-xl-center">
              {t('otherService.chatGpt.description')}
            </p>
          </div>
        </div>
        <div
          className="d-flex flex-column justify-content-between p-4 shadow rounded-lg bg-white mb-3 mx-3 mb-xl-0"
          style={{ maxWidth: isMobile ? "unset" : 320 }}
        >
          {isMobile && (
            <h4 className="font-weight-900 text-freiscop text-center mb-2 mb-md-0">
              <p>
                {t('otherService.vesselTracking.title')}
                <br />
                {t('otherService.vesselTracking.subtitle')}
              </p>
            </h4>
          )}
          <div className="d-flex flex-row flex-md-column align-items-center justify-content-between">
            <div className="d-flex flex-column align-items-center">
              {!isMobile && (
                <h4 className="font-weight-900 text-freiscop text-center">
                  <p>
                    {t('otherService.vesselTracking.title')}
                    <br />
                    {t('otherService.vesselTracking.subtitle')}
                  </p>
                </h4>
              )}
              <div className="mr-3 mr-md-0 my-md-4">
                <img
                  width={isMobile ? "60px" : "unset"}
                  src="/img/info/cursor.png"
                  alt="cursor"
                />
              </div>
            </div>
            <p className="h6 m-0 text-xl-center">
              {t('otherService.vesselTracking.description')}
            </p>
          </div>
        </div>
        <div
          className="d-flex flex-column justify-content-between p-4 shadow rounded-lg bg-white mb-3 mx-3 mx-xl-0 mb-xl-0"
          style={{ maxWidth: isMobile ? "unset" : 320 }}
        >
          {isMobile && (
            <h4 className="font-weight-900 text-freiscop text-center mb-2 mb-md-0">
              <p>
                {t('otherService.creditInfo.title')}
                <br />
                {t('otherService.creditInfo.subtitle')}
              </p>
            </h4>
          )}
          <div className="d-flex flex-row flex-md-column align-items-center justify-content-between">
            <div className="d-flex flex-column align-items-center">
              {!isMobile && (
                <h4 className="font-weight-900 text-freiscop text-center">
                  <p>
                    {t('otherService.creditInfo.title')}
                    <br />
                    {t('otherService.creditInfo.subtitle')}
                  </p>
                </h4>
              )}
              <div className="mr-3 mr-md-0 my-md-4">
                <img
                  width={isMobile ? "60px" : "unset"}
                  src="/img/info/check_doc.png"
                  alt="check_doc"
                />
              </div>
            </div>
            <p className="h6 m-0 text-xl-center">
              {t('otherService.creditInfo.description')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
